import {Injectable, inject} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ApiNotificationResponseDto} from '@birco/rainmesh-api';
import {NotificationToastComponent} from '../components/notification-toast/notification-toast.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationToastService {
  private snackBar = inject(MatSnackBar);
  private shownNotificationIds = new Set<string>();

  show(notification: ApiNotificationResponseDto) {
    if (!notification.id || notification.readAt || this.shownNotificationIds.has(notification.id)) {
      return;
    }

    this.shownNotificationIds.add(notification.id);

    this.snackBar.openFromComponent(NotificationToastComponent, {
      data: {notification},
      duration: 8000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }
}
